import { indexOf, compact } from 'lodash';

const menus = [
  {
    slug: '/feedback/decisions',
    label: 'Buyer Decisions',
    key: 'buyer_decisions',
  },
  {
    slug: '/feedback/experience',
    label: 'Customer Experience',
    key: 'customer_experience',
  },
  /*
  {
    slug: '/feedback/exclusions',
    label: 'Excluded',
    key: 'exclusion',
  },
  */
  {
    slug: '/feedback/progress-dashboard',
    label: 'Progress Dashboard',
    key: 'progress_dashboard',
  },
  {
    slug: '/feedback/dashboard',
    label: 'My Dashboard',
    key: 'dashboard',
  },
];

export default (user, organization, canSeeAllPages) => {
  if (user._id) {
    const organizationRole = user.organization_role;
    const organizationRules = organization ? organization.role_access_rules || {} : {};
    const organizationRoleRules = organizationRules[organizationRole] || {};
    const features = organization ? organization.features : {};
    return compact(menus.map((menu) => {
      const siteEnabled = features[menu.key] === true;
      const permissionEnabled = indexOf(['ALL', 'OWNERSHIP'], organizationRoleRules[menu.key]) >= 0;
      const featureEnabled = siteEnabled && permissionEnabled;
      if ((canSeeAllPages || featureEnabled)) {
        return menu;
      }
      return null;
    }));
  }
  return [];
};
